<template>
    <v-flex md3 class="pa-2">
        <v-card raised :href="redirection_link" target="_blank"
                class="mx-auto">
            <v-list-item class="py-3">
                <img height="35" :src="require('@/assets/visa-services/'+service_icon)"/>
                <v-list-item-content class="ml-4">
                    <v-list-item-title class="headline"><span style="font-size: 17px;color: #0065D8; font-weight: bold">{{title}}</span></v-list-item-title>
                    <v-list-item-subtitle><span style="font-size: 13px;font-weight: bold; color: #E7492E;">{{sub_title}}</span></v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item-subtitle class="pl-4 pb-3 pt-1"><v-icon class="" >mdi-hand-pointing-right</v-icon><span style="color: #000000; font-weight: bold; font-style: normal;font-size: 12px;">{{info}}</span></v-list-item-subtitle>

        </v-card>
    </v-flex>
</template>

<script>
    export default {
        name: "HomepageItem",
        props: {
            redirection_link: {
                type: String,
                default: ""
            },
            title: {
                type: [String, Number, Boolean],
                default: false
            },
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            sub_title: {
                type: [String, Number, Boolean],
                default: "n/a"
            },
            info: {
                type: [String, Number, Boolean],
                default: "n/a"
            },
            service_icon: {
                type: [String],
                default: ''
            },
            showModal: {
                type: [String, Number, Boolean],
                default: false
            }
        },
        data() {
            return {
                showDialog: false,
                selectedEntryPoint: ''
            }
        },
        async mounted() {
        },
        computed: {
        },
        methods: {

        },
    }
</script>

